import React from 'react'

import FormNavigationButtons from './FormNavigationButtons'
import IpsaTextField from './Form/IpsaTextField'
import IpsaSelectField from './Form/IpsaSelectField'
import { IpsaDateField } from './Form/IpsaFormattedFields'
import { states } from '../../../variables/constants'
import { IpsaMoneyField, IpsaPercentField, IpsaNumberField } from './Form/IpsaFormattedFields'

const ClientInformationStep = ({ clientId, onSave }) => (
    <>
        <div id="new-client-1" className="new-client-form animated-form">
            <h2>Personal & Income Data</h2>
            <div className="col-section col-no-margin">
                <div className="col-xs-12 col-md-6">
                    <IpsaTextField name="client.firstName" type="text" label="First Name" />
                </div>
                <div className="col-xs-12 col-md-6">
                    <IpsaTextField name="client.lastName" type="text" label="Last Name" />
                </div>
                <div className="col-xs-12 col-md-6">
                    <IpsaDateField
                        name="client.dob"
                        type="text"
                        label="Date of Birth"
                        placeholder="MM-DD-YYYY"
                    />
                </div>
                <div className="col-xs-12 col-md-6">
                    <IpsaMoneyField
                        name="client.annualBaseIncome"
                        type="text"
                        label="Annual Base Income"
                    />
                </div>
                <div className="col-xs-12 col-md-6">
                    <IpsaMoneyField
                        name="client.bonus"
                        type="text"
                        label="Annual Bonus/Commission/K1"
                    />
                </div>
                <div className="col-xs-12 col-md-6">
                    <IpsaSelectField
                        placeholder="Select Annual Income Increase %"
                        values={['0%', '1%', '2%', '3%', '4%', '5%', '6%']}
                        name="client.annualIncrease"
                        label="Annual Income Increase %"
                    />
                </div>
                <div className="col-xs-12 col-md-6">
                    <IpsaPercentField
                        name="client.taxBracket"
                        type="text"
                        label="Estimated Tax %"
                    />
                </div>

                <div className="col-xs-12 col-md-6">
                    <IpsaNumberField
                        name="client.retirementAge"
                        type="text"
                        label="Estimated Retirement Age"
                    />
                </div>
            </div>
        </div>
        <FormNavigationButtons
            section="client"
            next="coverage"
            clientId={clientId}
            onSave={onSave}
        />
    </>
)

export default ClientInformationStep
